import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import cl from 'classnames'

import polarisConfig from './polarisConfig'
import ReviewCard from './ReviewCard'
import { LAYOUT_CLASSES, useBreakpointClasses } from './Reviews.style'

// The reviews in the Polaris widget's own markup, with its options and styles
const StaticReviews = ({ reviews }) => {
  const ref = useRef(null)
  const breakpointClasses = useBreakpointClasses(ref)

  return (
    <div className='ElementsWidget-prefix'>
      <div
        ref={ref}
        className={cl('ElementsWidget', LAYOUT_CLASSES[polarisConfig.options.layout], breakpointClasses)}
        style={polarisConfig.styles}
      >
        <div className='ElementsWidget__inner'>
          <div className='ElementsWidget__list'>
            <div className='R-ContentList-container'>
              <div className='R-ContentList'>
                {reviews.map((review) => (
                  <ReviewCard key={`${review.author}-${review.date}`} {...review} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

StaticReviews.propTypes = {
  reviews: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default StaticReviews
